import { useCallback } from 'react';

type Reason = 'backdropClick' | 'escapeKeyDown';

type UseModalCloseHandlerArgs = {
  onClose: () => void;
};

export const useModalCloseHandler = ({ onClose }: UseModalCloseHandlerArgs) => {
  const handleClose = useCallback(
    (_event: unknown, reason?: Reason) => {
      if (reason === 'escapeKeyDown') {
        return;
      }

      onClose();
    },
    [onClose],
  );

  return handleClose;
};
